import _ from "underscore";

function intersection(...args) {
  args.pop();
  return _.intersection(...args);
}

export default intersection;
